const FailedErrorMessage = "Error: Server down. We're working to fix it";
export default FailedErrorMessage;
